import { render, staticRenderFns } from "./IM_1_2.vue?vue&type=template&id=606226fa&"
import script from "./IM_1_2.vue?vue&type=script&lang=js&"
export * from "./IM_1_2.vue?vue&type=script&lang=js&"
import style0 from "./IM_1_2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports